module.exports = __webpack_public_path__ + "img/banner-left-m.8802dcf8.png";